import initialState from './shared';

export default { ...initialState };



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/tables/initialState/dashboardTemplates.js